var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v("Export Notifications")]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "col-md-12 m-b-lg" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-success col-md-2",
            on: { click: _vm.exportNotifications },
          },
          [_vm._m(0)]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Import Notifications")]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c(
        "div",
        { staticClass: "col-md-12 p-h-xs" },
        [
          _c("input", {
            attrs: { type: "file" },
            on: {
              change: (output) => {
                _vm.setImportedFile(output)
              },
            },
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-success col-md-2 m-b-lg",
              attrs: {
                type: "submit",
                click: () => {
                  return _vm.handleImportCallback("import-notifications", 0)
                },
              },
            },
            [_vm._v("\n        Import & Keep Existing\n      ")]
          ),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-danger col-md-2 m-b-lg m-l-md",
              attrs: { type: "submit", click: _vm.confirmNotificationImport },
            },
            [_vm._v("\n        Import & Override\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", { staticClass: "fa fa-cloud-download" }),
      _vm._v(" Export Notifications"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }